import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { type DefaultMapKeys, Typography } from '@gds/Typography/Typography';

import type { VehicleAttributesProps } from '../VehicleAttributes.entity';

import styles from './FinancingDetails.module.css';

type FinancingDetailsProps = Pick<
  VehicleAttributesProps,
  'isStockUnavailable' | 'strings' | 'vehicle'
> & {
  isFinanceFirst?: boolean;
  isScrolling?: boolean;
  hasDiscount: boolean;
};

export const FinancingDetails = ({
  isStockUnavailable,
  strings,
  vehicle,
  isFinanceFirst = false,
  isScrolling,
  hasDiscount,
}: FinancingDetailsProps) => {
  const financeRate = vehicle.finance?.rate;
  const financeProduct = vehicle.finance?.product;
  const isCgiVehicle = vehicle.dealer.fdlConditions === 'cgi_fr';
  const shouldShowOrPayString = isCgiVehicle;

  let variant: DefaultMapKeys | undefined;

  if (isFinanceFirst) {
    if ((!hasDiscount && !isScrolling) || hasDiscount) {
      variant = 'h3';
    }
    if (isScrolling && !hasDiscount) {
      variant = 'h5';
    }
  }
  const formattedMonthlyPrice = getFormattedCurrency(Math.ceil(financeRate!));

  const fincalcCta = (
    <Typography
      Component="span"
      className={!variant ? styles.financingDetails : undefined}
      {...(variant && { variant })}
    >
      {shouldShowOrPayString && strings.orPay} {formattedMonthlyPrice} {strings.financePriceLabel}{' '}
      <span className={styles.financeType}>{financeProduct}</span>
    </Typography>
  );

  if (isStockUnavailable) {
    return fincalcCta;
  }

  return <div className={styles.wrapper}>{fincalcCta}</div>;
};
